import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Artistic%20editorial%20fashion%20flat%20lay%20composition%20with%20curated%20clothing%20pieces%20and%20accessories%20arranged%20in%20an%20elegant%20scattered%20pattern%20on%20a%20warm%20sandstone%20colored%20surface%2C%20soft%20diffused%20daylight%20from%20a%20large%20window%20creating%20gentle%20dimensional%20shadows%2C%20luxurious%20yet%20approachable%20aesthetic%20with%20terracotta%20cream%20and%20olive%20green%20tones%2C%20high%20end%20catalog%20photography%20with%20thoughtful%20negative%20space%20and%20organic%20arrangement%2C%20warm%20inviting%20atmosphere%20with%20sophisticated%20styling%20and%20rich%20textile%20textures&width=1800&height=900&seq=hero-main-v3-f8a2&orientation=landscape"
          alt="Mulebuy Spreadsheet Hub Background"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/18 to-black/35"></div>
      </div>

      <div className="relative z-10 w-full px-6 md:px-8 lg:px-12 py-20 md:py-28">
        <div className="flex flex-col lg:flex-row items-start lg:items-center gap-10 lg:gap-16 max-w-6xl mx-auto">
          <div className="flex-1">
            <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight">
              Mulebuy Spreadsheet<br />
              <span className="text-accent-400">Hub 2026</span>
            </h1>
            <h2 className="mt-4 text-base md:text-lg text-white/85 font-sans max-w-lg leading-relaxed">
              The Most Trusted Directory for Mulebuy Spreadsheet Resources, Comparisons &amp; Guides
            </h2>
            <p className="mt-4 text-sm md:text-base text-white/70 font-sans max-w-md">
              Find everything about <strong>Mulebuy spreadsheet systems</strong> in one structured, SEO-optimized platform.
            </p>
            <div className="flex flex-col sm:flex-row gap-3 mt-8">
              <a
                href="https://kaspreadsheet.com/"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center justify-center gap-2 px-6 py-3 text-sm font-semibold bg-primary-500 text-white rounded-full hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer"
              >
                Access Mulebuy Spreadsheet Database
                <i className="ri-arrow-right-line"></i>
              </a>
              <Link
                to="/mulebuy-spreadsheet-comparison-2026"
                className="inline-flex items-center justify-center gap-2 px-6 py-3 text-sm font-semibold bg-white/15 text-white border border-white/30 rounded-full hover:bg-white/25 transition-all whitespace-nowrap cursor-pointer backdrop-blur-sm"
              >
                Compare Spreadsheet Options
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          </div>

          <div className="flex-1 hidden lg:block">
            <div className="rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Warm%20editorial%20product%20photography%20of%20lifestyle%20accessories%20and%20fashion%20items%20arranged%20on%20a%20mid%20century%20modern%20credenza%20with%20a%20trailing%20plant%20and%20art%20books%2C%20golden%20afternoon%20light%20streaming%20through%20sheer%20curtains%2C%20sophisticated%20boutique%20aesthetic%20with%20cognac%20leather%20and%20sage%20green%20accents%2C%20aspirational%20interior%20styling%20with%20curated%20personal%20collection%20feel%2C%20rich%20warm%20tones%20and%20soft%20directional%20shadows&width=900&height=600&seq=hero-side-v3-e7d1&orientation=landscape"
                alt="Mulebuy Spreadsheet Resources"
                className="w-full h-auto rounded-2xl"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}